import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';

export default class ToggleDetailedDates {
  constructor(context) {
    this.context = context;
  }

  run() {
    const preferences = this.context.stores.agentPreferences.get();
    preferences.toggleDetailedDates();

    const params = {
      detailedDatesEnabled: preferences.detailedDatesEnabled,
    };
    this.context.analytics.track('Detailed Dates Toggled', params);
    this.context.analytics.updateUser(params);
    setAgentPreferences(this.context, preferences);
  }
}
